import useAccessVoter from "v4/hooks/useAccessVoter";

export default function ManageActionsVoter() {
    const {hasRole} = useAccessVoter();

    const canManageActions = () => {
        return hasRole('ROLE_SUPERADMIN') || hasRole('ROLE_SYSTEM');
    }

    return {
        canManageActions
    };
}
